import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { httpFactory } from "@angular/http/src/http_module";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Bike } from "./../models/bike";
import { filter } from "rxjs/operators";
import { HeartBeat } from "../models/heartbeat";
import {
  getFileNameFromResponseContentDisposition,
  checkIfTruncated,
  saveFile,
} from "./utils/file-download-helper";

@Injectable()
export class BikeService {
  API_BIKE_URL = environment.serverUrl + "api/1/bikes";
  API_HEARBEAT_URL = environment.serverUrl + "api/1/heartbeats";

  constructor(private http: HttpClient) {}

  getFormattedUrl(
    pageIndex: number,
    itemPerPage: number,
    filters: any,
    criterias: any
  ): string {
    const offset = (pageIndex - 1) * itemPerPage; // records offset to display the specific range

    let url =
      this.API_BIKE_URL +
      "?pagination=" +
      offset +
      "-" +
      itemPerPage +
      "&sorts=";

    if (criterias.size === 0) {
      // if no sorts criterias => sort by id
      url += "bike.name asc";
    } else {
      Array.from(criterias.keys()).forEach(
        (c) => (url += c + (criterias.get(c) === true ? " asc" : " desc") + ",")
      );
      url = url.substring(0, url.length - 1);
    }

    if (filters !== undefined) {
      const filtersAsString = JSON.stringify(filters, (key, value) => {
        if (value !== null && value !== undefined && value !== "") {
          return value;
        }
      });

      if (filtersAsString.length > 2) {
        url += "&filters=" + filtersAsString;
      }
    }

    return url;
  }

  getPaginatedFilteredSortedBikes(
    pageIndex: number,
    itemPerPage: number,
    filters: any,
    criterias: any
  ): Observable<any> {
    const url = this.getFormattedUrl(
      pageIndex,
      itemPerPage,
      filters,
      criterias
    );
    return this.http
      .get<any>(encodeURI(url), { observe: "response" })
      .map((response) => {
        return {
          headers: response.headers,
          res: <Bike[]>response.body,
        };
      });
  }

  downloadXLSFile(
    pageIndex: number,
    itemPerPage: number,
    filters: Map<string, any>,
    criterias: Map<string, boolean>
  ): any {
    const url = this.getFormattedUrl(
      pageIndex,
      itemPerPage,
      filters,
      criterias
    );
    return this.http
      .get<any>(encodeURI(url), {
        headers: { Accept: "application/octet-stream" },
        responseType: "blob" as "json",
        observe: "response",
      })
      .map((response) => {
        const fileName = getFileNameFromResponseContentDisposition(
          response,
          "bikes.xls"
        );
        const isTruncated = checkIfTruncated(response);
        saveFile(response.body.slice(), fileName);
        return isTruncated;
      });
  }

  get(bikeId: number): Observable<Bike> {
    return this.http.get<Bike>(encodeURI(this.API_BIKE_URL + "/" + bikeId));
  }

  update(bike: Bike) {
    const uri = encodeURI(this.API_BIKE_URL + "/" + bike.id);
    return this.http.put(uri, bike);
  }

  create(bike: Bike) {
    return this.http.post(encodeURI(this.API_BIKE_URL), bike);
  }

  delete(bike: Bike, deleteLock: boolean) {
    return this.http.delete(
      encodeURI(
        this.API_BIKE_URL + "/" + bike.id + "?supressLock=" + deleteLock
      )
    );
  }

  getBikeFromGroup(groupId: any): Observable<any> {
    const url = this.API_BIKE_URL + '?filters={"grp.id":"' + groupId + '"}';

    return this.http
      .get<any>(encodeURI(url), { observe: "response" })
      .map((response) => {
        return {
          headers: response.headers,
          res: <Bike[]>response.body,
        };
      });
  }

  getTypes(): Observable<string[]> {
    return this.http.get<string[]>(`${this.API_BIKE_URL}/types`);
  }

  getHeartBeat(bikeId: number): Observable<HeartBeat[]> {
    return this.http.get<HeartBeat[]>(
      encodeURI(this.API_HEARBEAT_URL + "?bikeId=" + bikeId)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/bike.service.ts